export default class Character {
    constructor(name, effect, autosucceed = false) {
        this.name = name
        this.effect = effect
        this.autosucceed = autosucceed
    }
}
